import React from "react";
import { Modal, Button } from "react-bootstrap";
import QueryBuilder from "../forms/QueryBuilder"; // adjust path

export default function CommQueryBuilderModal({ show, onClose, fhirClient, contextProvider, setSelectedComm }) {
    return (
        <Modal
            show={show}
            onHide={onClose}
            backdrop="static"   // prevent closing on outside click
            keyboard={false}    // prevent closing on ESC key
            size="lg"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Search Communications</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <QueryBuilder
                    fhirClient={fhirClient}
                    contextProvider={contextProvider}
                    onClose={onClose}  
                    setSelectedComm={setSelectedComm}

                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
